/** @file GL-free page-table checks: one premultiplied, page-sized RGBA8 image per TexturePages entry. */
import type { TexturePages } from '@pose2d/geometry/types';
import type { RgbaImage } from '@pose2d/math/types';
import { invariant } from '@pose2d/std/invariant';

/** Throws unless images[i] is a premultiplied (W2-23: never converted here) w × h RGBA8 image for pages[i]. */
export function checkPageImages(textures: TexturePages, images: readonly RgbaImage[]): void {
  invariant(images.length === textures.pages.length, `uploadPages: ${images.length} images for ${textures.pages.length} pages`);
  images.forEach((image, i) => {
    const page = textures.pages[i];
    invariant(page, `uploadPages: image ${i} has no TexturePages entry`);
    invariant(image.premultiplied, `uploadPages: image ${i} must be premultiplied (image-io premultiply)`);
    invariant(image.width === page.w && image.height === page.h, `uploadPages: image ${i} is ${image.width}x${image.height} but page ${page.id} is ${page.w}x${page.h}`);
    invariant(image.data.length === image.width * image.height * 4, `uploadPages: image ${i} data length is not width x height x 4`);
  });
}
